import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Api } from '../util/api';

@Injectable()
export class EnumsService {
  private endpoint: string = 'enums';

  constructor(private api: Api) {
  }

  getEnums(): Observable<any> {
    return this.api.get(`${this.endpoint}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/enums.service.ts